import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChartOfAccountsV2 = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M16 21V19.125C16 18.0895 17.1193 17.25 18.5 17.25H21M16 21H9C7.89543 21 7 20.1046 7 19L7 10C7 8.89543 7.89543 8 9 8H19C20.1046 8 21 8.89543 21 10V17.25M16 21L18 19.5L21 17.25",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16 13L18 13",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7 13.7071L4.39222 14.2287C3.15464 14.4762 2 13.5296 2 12.2675V9.59174V5.36013C2 4.75159 2.54129 4.28705 3.14742 4.34123C8.82204 4.84846 10.2061 2.5259 15.1577 3.08855C15.6434 3.14374 16 3.5654 16 4.05424V7.20712",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5 5.20703V5.20703C5 6.3116 4.10457 7.20703 3 7.20703H2",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5 13.207V13.207C5 12.1025 4.10457 11.207 3 11.207H2",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13 3.20703V4.20703C13 5.3116 13.8954 6.20703 15 6.20703H16",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.5 11.9211C12.3284 11.9211 13 12.4984 13 13.2105M11.5 11.9211C10.6716 11.9211 10 12.4984 10 13.2105C10 13.9227 10.6716 14.5 11.5 14.5C12.3284 14.5 13 15.0773 13 15.7895C13 16.5016 12.3284 17.0789 11.5 17.0789M11.5 11.9211V11M11.5 17.0789C10.6716 17.0789 10 16.5016 10 15.7895M11.5 17.0789V18",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgChartOfAccountsV2);
export default ForwardRef;
